var _QueryLoaderHelloQuery;
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useEffect, Suspense } from 'react';
import { useQueryLoader, graphql } from 'react-relay';

// Local Definitions

import { PreloadedTestData } from "./common";
const testQuery = _QueryLoaderHelloQuery !== void 0 ? _QueryLoaderHelloQuery : (_QueryLoaderHelloQuery = require("./__generated__/QueryLoaderHelloQuery.graphql"), _QueryLoaderHelloQuery.hash && _QueryLoaderHelloQuery.hash !== "b92d001ab0208bd484a99f77c274d5ef" && console.error("The definition of 'QueryLoaderHelloQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _QueryLoaderHelloQuery);

/**
 * This is the component description.
 */
const QueryLoader = () => {
  const [queryReference, loadQuery] = useQueryLoader(testQuery);
  useEffect(() => {
    loadQuery({});
  }, []);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: "loading"
  }, queryReference ? /*#__PURE__*/React.createElement(PreloadedTestData, {
    queryReference: queryReference,
    query: testQuery
  }) : null);
};
QueryLoader.defaultProps = {
  // someProp:false
};
export default QueryLoader;